"use client";

import { storyblokEditable, StoryblokComponent } from "@storyblok/react/rsc";

import { GridContainer } from "@/components/layout/GridContainer";
import { RichTextField } from "@/components/typography/RichTextField";
import { cn } from "@/lib/utils";

type StepsSectionBackgroundColor = "none" | "sand-10" | "sand-100" | "sky-20";

const backgroundColorClasses: Record<StepsSectionBackgroundColor, string> = {
  none: "",
  "sand-10": "bg-sand-10",
  "sand-100": "bg-sand-100",
  "sky-20": "bg-sky-20",
};

type StepsSectionStoryblok = {
  title?: string;
  text?: string;
  background_color?: StepsSectionBackgroundColor;
  items?: any[];
  _uid: string;
  component: "steps_section";
  [k: string]: any;
};

type StepsSectionProps = {
  blok: StepsSectionStoryblok;
};

const StepsSection = ({ blok }: StepsSectionProps) => {
  const bgColor = (blok.background_color || "none") as StepsSectionBackgroundColor;
  const bgClass = backgroundColorClasses[bgColor];

  return (
    <section className={cn("py-12", bgClass)} {...storyblokEditable(blok)}>
      <GridContainer>
        <div className="col-span-12 md:col-span-8  md:col-start-3 lg:col-span-8 lg:col-start-3">
          {/* Title + Text */}
          {(blok.title || blok.text) && (
            <div className="flex flex-col gap-6">
              {blok.title && <h2 className="text-headline-xl">{blok.title}</h2>}
              {blok.text && <RichTextField value={blok.text} className="text-copy" />}
            </div>
          )}

          {/* Steps */}
          {blok.items && blok.items.length > 0 && (
            <div className="mt-6 flex flex-col gap-4">
              {blok.items.map((nestedBlok: any) => (
                <StoryblokComponent blok={nestedBlok} key={nestedBlok._uid} />
              ))}
            </div>
          )}
        </div>
      </GridContainer>
    </section>
  );
};

export default StepsSection;
